<template>
  <div class="diy-modal__content-close">
    <AppButtonIcon effect="rotate" @click="submitCloseAciton" />
  </div>
</template>

<script>
// Components
import AppButtonIcon from 'Ui/AppButtonIcon'

export default {
  name: 'DIYModalCloseButtton',

  components: {
    AppButtonIcon,
  },

  methods: {
    submitCloseAciton() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped></style>
